module.exports = __webpack_public_path__ + "media/images/mobile/city_img/i-b3636017bdd03fe3383bd93edd2175c2.jpg";